import { useState, useEffect } from "react";
import axios from "axios";
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import Stack from '@mui/material/Stack';
import Alert from '@mui/material/Alert';
import Pagination from '@mui/material/Pagination';
import { PaginationBtn } from "../../../../styledEvents";
import CircularProgress from '@mui/material/CircularProgress';
import { ContainerSearch, ComponentTitle } from "../styledGlobalModal";
import { ModalAlvaraLicenca, ContainerTableAlvaraLicenca, ContainerTableAl, BtnExportExcel, ContainerControllers, ItemBtnExport, ContainerBusca } from "./styled";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
    TableContainer,
    TableBody,
    TableColumn,
    TableHeader,
    ColumnTitle,
    TableTitle,
    TableHead,
    TableRowOrdemService
} from "../../../../CSSGlobal";
import listTables from "./tableTitles.json"
import { Button, Input, Skeleton } from 'antd';
import { SearchOutlined, EditOutlined, FileExcelOutlined } from '@ant-design/icons';
import { useAccordionButton } from "react-bootstrap";
import ModalEditarAlvara from "./ModalEditarAlvara";

export function AlvarasLicenca() {

    const [exporting, setExporting] = useState(false);
    const [loading, setLoading] = useState(false);
    const [titleTable, setTitleTable] = useState(listTables);
    const [isTable, setIsTable] = useState(false);
    const [listTableFilter, setListTableFilter] = useState([]);
    const [isPage, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const numberPage = 10;
    const [isExcelAvailable, setIsExcelAvailable] = useState(false);
    const [clientParam, setClientParam] = useState("");
    const [initialLoad, setInitialLoad] = useState(true);
    const [isModalEditVisble, setIsModalEditVisible] = useState(false);
    const [alvaraId, setAlvaraId] = useState("");
    const [tipoList, setTipoList] = useState([]);
    const [situacaoList, setSituacaoList] = useState([]);

    useEffect(() => {
        let height = 1000;
        window.parent.postMessage({ frameHeight: height }, "*");
      },);

    const fetchData = async () => {
        const url = "/portal/rest/contador/alvara/pesquisar";
        const param = {
            alvara: {
                cliente: {
                    nome: clientParam,
                }
            },
            paginacao: {
                pagina: isPage,
                tamanho: numberPage,
            }
        };

        setLoading(true);
        try {
            const response = await axios.post(url, param, { withCredentials: true });
            if (response.data.alvaras && response.data.alvaras.length > 0) {
                setListTableFilter(response.data.alvaras);
                setIsTable(true);
                setIsExcelAvailable(true);
                setTotalPages(response.data.paginacao.totalPaginas);

            } else {
                setListTableFilter({});
                setTotalPages(0);
            }
        } catch {
            toast.error("Não foi possível encontrar os dados, tente novamente mais tarde.");


        } finally {
            setLoading(false);
        }
    }

    const tipoListar = async () => {
        const url = "/portal/rest/cliente/alvaras/tipo/listar";
        const param = {}

        try {
            const response = await axios.post(url, param, { withCredentials: true });

            setTipoList(response.data);

        } catch {

        }
    }

    const situacaoListar = async () => {
        const url = "/portal/rest/cliente/alvaras/situacao/listar";
        const param = {}

        try {
            const response = await axios.post(url, param, { withCredentials: true });
            setSituacaoList(response.data);
        } catch {

        }
    }

    const exportToExcel = async () => {
        const excelUrl = `/portal/rest/contador/alvara/export/excel?report=2&termo=${clientParam}`;

        try {
            setExporting(true);
            const response = await axios.get(excelUrl, {
                withCredentials: true,
                responseType: 'blob',
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'lista-alvaras.xlsx');
            document.body.appendChild(link);
            link.click();

            toast.success("Arquivo baixado com sucesso!");
        } catch (error) {
            console.error('Erro ao exportar os dados:', error);
            toast.error('Erro ao exportar os dados');
        } finally {
            setExporting(false);
        }
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        setInitialLoad(false); // Forçar nova carga de dados ao mudar a página
    };

    const changeClientParam = (e) => {
        setClientParam(e.target.value);
        setInitialLoad(true);
        setPage(1);
    }

    const handleData = () => {
        fetchData();
    }

    const handleModalEditVisible = (id) => {
        setIsModalEditVisible(!isModalEditVisble);
        setAlvaraId(id);
    }

    return (
        <ModalAlvaraLicenca>
            <ContainerTableAlvaraLicenca>
                <ContainerTableAl>
                    <ContainerSearch>
                        <ContainerControllers>
                            <ComponentTitle>
                                <span>{"Alvarás e Licenças"}</span>
                            </ComponentTitle>
                            {isExcelAvailable && (
                                <ItemBtnExport>
                                    <div>
                                        <div className="iconExe">
                                            {!exporting && (
                                                <BtnExportExcel onClick={exportToExcel} disabled={loading}>
                                                    <FileExcelOutlined className="icon-btn" />
                                                    Exportar Alvarás
                                                </BtnExportExcel>
                                            )}
                                        </div>
                                        {exporting && (
                                            <div>
                                                <CircularProgress
                                                    className="cicleProgress"
                                                    disableShrink
                                                />
                                            </div>
                                        )}
                                    </div>
                                </ItemBtnExport>
                            )}
                        </ContainerControllers>
                    </ContainerSearch>
                    <ContainerBusca>

                        <Input
                            placeholder="Cliente ID"
                            className="input-id"
                            value={clientParam}
                            onChange={changeClientParam}
                        />
                        <Button className="button-prox" onClick={handleData}>
                            <SearchOutlined />
                            Próximo
                        </Button>

                    </ContainerBusca>
                    {loading && (
                        <Box sx={{ width: "100%" }}>
                            <LinearProgress />
                        </Box>
                    )}
                    {loading ? (
                        <>
                            {[...Array(2)].map((_, index) => (
                                <Skeleton
                                    active
                                    key={index}
                                    variant="rectangular"
                                    width="100%"
                                    height={10}
                                />
                            ))}
                        </>
                    ) : (
                        <>
                            {isTable && (
                                <>
                                    <TableHeader>
                                        <TableHead>
                                            {titleTable[0].titles.map((item, index) => {
                                                return (
                                                    <ColumnTitle key={index} id={index}>
                                                        <TableTitle>
                                                            <span>{item.title}</span>
                                                        </TableTitle>
                                                    </ColumnTitle>
                                                );
                                            })}
                                        </TableHead>
                                    </TableHeader>
                                    <TableContainer>
                                        <TableBody>
                                            <>
                                                {listTableFilter.map((item, index) => (
                                                    <>
                                                        <TableRowOrdemService key={index}>
                                                            <TableColumn>
                                                                <span>
                                                                    {item.cliente?.id}
                                                                </span>
                                                            </TableColumn>
                                                            <TableColumn>
                                                                <span>
                                                                    {item.cliente.carteira.id}/{item.cliente.equipe.id}
                                                                </span>
                                                            </TableColumn>
                                                            <TableColumn>
                                                                <span>
                                                                    {item.tipo.nome}
                                                                </span>
                                                            </TableColumn>
                                                            <TableColumn>
                                                                <span>
                                                                    {item.situacao.nome}
                                                                </span>
                                                            </TableColumn>
                                                            <TableColumn>
                                                                <span>
                                                                    {item.dataExpiracao}
                                                                </span>
                                                            </TableColumn>
                                                            <TableColumn>
                                                                <Button className="button-prox" onClick={() => handleModalEditVisible(item.id)}>
                                                                    <EditOutlined className="icon-btn" />
                                                                    Editar
                                                                </Button>
                                                            </TableColumn>
                                                        </TableRowOrdemService>
                                                    </>
                                                ))}
                                            </>
                                        </TableBody>
                                        <PaginationBtn>
                                            <Stack spacing={1}>
                                                <Pagination
                                                    count={Math.ceil(totalPages / numberPage)}
                                                    page={isPage}
                                                    onChange={handleChangePage}
                                                    size="small"
                                                />
                                            </Stack>
                                        </PaginationBtn>
                                    </TableContainer>
                                </>
                            )}
                        </>
                    )}
                </ContainerTableAl>
            </ContainerTableAlvaraLicenca>
            {isModalEditVisble && (
                <ModalEditarAlvara
                    isOpen={isModalEditVisble}
                    onClose={() => setIsModalEditVisible(false)}
                    id={alvaraId}
                    listTipo={tipoList}
                    listSituacao={situacaoList}
                    fetchData={fetchData}
                />
            )}
        </ModalAlvaraLicenca>
    );
}

export default AlvarasLicenca;